import { AT } from '../../../actions/actionTypes';
import { ActivitiesState, Activity } from './model';
import { ActivitiesStateDefault } from './defaults';
import {
  latestError,
  latestFetch,
  latestSuccess,
  moreError,
  moreFetch,
  moreSuccess,
  remove,
} from '../../historical/reducer';
import { IHistoricalData } from '../../historical/model';
import { MessageType } from '../../../core/localization';
import { areEqual } from './utils';
import Logger from '../../../libs/logger';  import { LogArea } from '../../../libs/logger/const';

const defaultState: ActivitiesState = ActivitiesStateDefault;

export default function (state = defaultState, action: any) {
  switch (action.type) {
    case AT.DIALOG_TRANSFER_ACTIVITIES_CLOSED_MORELOGS_FETCH: {
      Logger.info(
        [AT.DIALOG_TRANSFER_ACTIVITIES_CLOSED_MORELOGS_FETCH, action],
        LogArea.Redux
      );
      const closedTransfers = moreFetch(state.closedTransfers);
      return { ...state, closedTransfers };
    }

    case AT.DIALOG_TRANSFER_ACTIVITIES_CLOSED_MORELOGS_SUCCESS: {
      Logger.info(
        [AT.DIALOG_TRANSFER_ACTIVITIES_CLOSED_MORELOGS_SUCCESS, action, state],
        LogArea.Redux
      );
      const data: IHistoricalData<Activity> = action.payload;
      const closedTransfers = moreSuccess(
        state.closedTransfers,
        data,
        areEqual
      );
      return { ...state, closedTransfers };
    }

    case AT.DIALOG_TRANSFER_ACTIVITIES_CLOSED_MORELOGS_ERROR: {
      Logger.info(
        [AT.DIALOG_TRANSFER_ACTIVITIES_CLOSED_MORELOGS_ERROR, action, state],
        LogArea.Redux
      );
      const errorMessage: MessageType = action.payload;
      const closedTransfers = moreError(state.closedTransfers, errorMessage);
      return { ...state, closedTransfers };
    }

    case AT.DIALOG_TRANSFER_ACTIVITIES_CLOSED_LATESTLOGS_FETCH: {
      Logger.info(
        [AT.DIALOG_TRANSFER_ACTIVITIES_CLOSED_LATESTLOGS_FETCH, action],
        LogArea.Redux
      );
      const closedTransfers = latestFetch(state.closedTransfers);
      return { ...state, closedTransfers };
    }

    case AT.DIALOG_TRANSFER_ACTIVITIES_CLOSED_LATESTLOGS_SUCCESS: {
      Logger.info(
        [
          AT.DIALOG_TRANSFER_ACTIVITIES_CLOSED_LATESTLOGS_SUCCESS,
          action,
          state,
        ],
        LogArea.Redux
      );
      const data: IHistoricalData<Activity> = action.payload;
      const closedTransfers = latestSuccess(
        state.closedTransfers,
        data,
        areEqual
      );
      return { ...state, closedTransfers };
    }

    case AT.DIALOG_TRANSFER_ACTIVITIES_CLOSED_LATESTLOGS_ERROR: {
      Logger.info(
        [AT.DIALOG_TRANSFER_ACTIVITIES_CLOSED_LATESTLOGS_ERROR, action, state],
        LogArea.Redux
      );
      const errorMessage: MessageType = action.payload;
      const closedTransfers = latestError(state.closedTransfers, errorMessage);
      return { ...state, closedTransfers };
    }

    /************************************************************* */

    case AT.DIALOG_TRANSFER_ACTIVITIES_OPEN_REMOVELOG: {
      Logger.info(
        [AT.DIALOG_TRANSFER_ACTIVITIES_OPEN_REMOVELOG, action, state],
        LogArea.Redux
      );
      const data: Activity = action.payload;
      const openTransfers = remove(state.openTransfers, data, areEqual);
      return { ...state, openTransfers };
    }

    case AT.DIALOG_TRANSFER_ACTIVITIES_OPEN_MORELOGS_FETCH: {
      Logger.info(
        [AT.DIALOG_TRANSFER_ACTIVITIES_OPEN_MORELOGS_FETCH, action],
        LogArea.Redux
      );
      const openTransfers = moreFetch(state.openTransfers);
      return { ...state, openTransfers };
    }

    case AT.DIALOG_TRANSFER_ACTIVITIES_OPEN_MORELOGS_SUCCESS: {
      Logger.info(
        [AT.DIALOG_TRANSFER_ACTIVITIES_OPEN_MORELOGS_SUCCESS, action, state],
        LogArea.Redux
      );
      const data: IHistoricalData<Activity> = action.payload;
      const openTransfers = moreSuccess(state.openTransfers, data, areEqual);
      return { ...state, openTransfers };
    }

    case AT.DIALOG_TRANSFER_ACTIVITIES_OPEN_MORELOGS_ERROR: {
      Logger.info(
        [AT.DIALOG_TRANSFER_ACTIVITIES_OPEN_MORELOGS_ERROR, action, state],
        LogArea.Redux
      );
      const errorMessage: MessageType = action.payload;
      const openTransfers = moreError(state.openTransfers, errorMessage);
      return { ...state, openTransfers };
    }

    case AT.DIALOG_TRANSFER_ACTIVITIES_OPEN_LATESTLOGS_FETCH: {
      Logger.info(
        [AT.DIALOG_TRANSFER_ACTIVITIES_OPEN_LATESTLOGS_FETCH, action],
        LogArea.Redux
      );
      const openTransfers = latestFetch(state.openTransfers);
      return { ...state, openTransfers };
    }

    case AT.DIALOG_TRANSFER_ACTIVITIES_OPEN_LATESTLOGS_SUCCESS: {
      Logger.info(
        [AT.DIALOG_TRANSFER_ACTIVITIES_OPEN_LATESTLOGS_SUCCESS, action, state],
        LogArea.Redux
      );
      const data: IHistoricalData<Activity> = action.payload;
      const openTransfers = latestSuccess(state.openTransfers, data, areEqual);
      return { ...state, openTransfers };
    }

    case AT.DIALOG_TRANSFER_ACTIVITIES_OPEN_LATESTLOGS_ERROR: {
      Logger.info(
        [AT.DIALOG_TRANSFER_ACTIVITIES_OPEN_LATESTLOGS_ERROR, action, state],
        LogArea.Redux
      );
      const errorMessage: MessageType = action.payload;
      const openTransfers = latestError(state.openTransfers, errorMessage);
      return { ...state, openTransfers };
    }

    default: {
      return state;
    }
  }
}
